import { actionTypes } from './constants';

export const stackComponentPagesActionTypes = {
  setSelectedRunIds: actionTypes.STACKCOMPONENT_PAGES_SET_SELECTED_RUN_IDS,
  setFetching: actionTypes.STACKCOMPONENT_PAGES_SET_FETCHING,
};
